module.exports = __webpack_public_path__ + "static/img/SF116WP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF116WP_1.png
// module id = m6Gq
// module chunks = 0